import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import type { Users } from 'modules/core/store/collections/users'
import users from 'modules/core/store/collections/users'
import AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Employees } from 'modules/employees/store/collections/employees'
import formAccessGroupMemberships from 'modules/surveys/store/collections/formAccessGroupMemberships'

import BodyLayout from './BodyLayout'

const useFilter = createComputed(
  (
    usersCollection: Users,
    accessGroup: AccessGroup,
    search: string,
    groupable_access_ids: number[]
  ) => {
    const isMemberStrategy = accessGroup.attributes.strategy === AccessGroup.Strategies.members

    if (isMemberStrategy) {
      const respondents_access_ids = formAccessGroupMemberships
        .filter({ access_group_id: accessGroup.attributes.id })
        .map((membership) => membership.attributes.access_id)

      return usersCollection.filter(
        (user) => respondents_access_ids.includes(user.get('id')) && user.matchesFullName(search)
      )
    } else {
      return usersCollection.filter(
        (user) => groupable_access_ids.includes(user.get('id')) && user.matchesFullName(search)
      )
    }
  }
)

interface Props {
  search: string
  accessGroup: AccessGroup
  employees: Employees
}

function Body({ search, accessGroup, employees }: Props) {
  const formUsers = useFilter(
    users,
    accessGroup,
    search,
    accessGroup.attributes.access_ids.map((id: number) => id)
  ).get()

  return <BodyLayout users={formUsers} employees={employees} />
}

export default observer(Body)
